import React__default from 'react';
import Row from '../../../node_modules/reactstrap/esm/Row.js';
import Col from '../../../node_modules/reactstrap/esm/Col.js';
import { Label, SortableContainer, SortableItem } from './styled.js';

var SortableList = (function (_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? "Items" : _ref$label,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    onSortEnd = _ref.onSortEnd,
    _removeHandler = _ref.removeHandler,
    noResultsText = _ref.noResultsText;
  return items.length ? /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Label, null, label), /*#__PURE__*/React__default.createElement(Row, null, /*#__PURE__*/React__default.createElement(Col, {
    xs: "12"
  }, /*#__PURE__*/React__default.createElement(SortableContainer, {
    onSortEnd: onSortEnd,
    useDragHandle: true
  }, items.map(function (_ref2, idx) {
    var label = _ref2.label;
    return /*#__PURE__*/React__default.createElement(SortableItem, {
      key: "item-".concat(label),
      index: idx,
      value: label,
      removeHandler: function removeHandler() {
        return _removeHandler(idx);
      }
    });
  }))))) : /*#__PURE__*/React__default.createElement(Label, null, noResultsText);
});

export { SortableList as default };
